import { render, staticRenderFns } from "./capitalDetail.vue?vue&type=template&id=0c8de56a&scoped=true&"
import script from "./capitalDetail.vue?vue&type=script&lang=js&"
export * from "./capitalDetail.vue?vue&type=script&lang=js&"
import style0 from "./capitalDetail.vue?vue&type=style&index=0&id=0c8de56a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8de56a",
  null
  
)

export default component.exports